module.exports = __webpack_public_path__ + "static/media/image.78d46b5c.png";